import {Component,Input, OnInit,ViewEncapsulation} from '@angular/core';
import {SmsMessageManageService} from "../smsmessage/smsmessage.service";
import {Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {FormValidator} from "../form.validator";
import {Offcanvas} from "./../form.offcanvas";
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;
declare var momentJs: any;


@Component({
  selector: 'app-sendSms',
  templateUrl: './sendSms.component.html',
  styleUrls: ['./sendSms.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [SmsMessageManageService,LoginService,FormValidator,Offcanvas]
})


export class SendSmsComponent {

  constructor(private router: Router, private loginservice: LoginService, private messageService: SmsMessageManageService, private  formValidator: FormValidator, private offcanvas: Offcanvas, private translate: TranslateService) {
  }

  getAuthToken = localStorage.getItem('usertoken');
  @Input() user_count: string;
  @Input() userType: string;
  @Input() studentType: string;
  @Input() sendTo: string;
  @Input() classList: any[];
  @Input() studentList: any[];
  reasonList = [];
  remainingSms = '';
  fetchReason() {
    this.reasonList = [];
    this.messageService.fetchReasonService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.reasonList = data;
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  fetchSubscriptionDetails(){
    this.messageService.fetchSubscriptionDetailsService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.remainingSms = data.smsRemaining;
        },
        async error => {
          const internalServiceErrorTranslation = await firstValueFrom(this.translate.get('internalServiceError')); 
          customToastr(internalServiceErrorTranslation, 'error');
        }
      );
  }
  canSendSms = false;
  leftSms = 0;
  getSmsData(){
    if(parseInt(this.user_count) > parseInt(this.remainingSms)){
      this.canSendSms = false;
    }
    else {
      this.canSendSms = true;
    }
    if(this.canSendSms){
      this.leftSms = parseInt(this.remainingSms) - parseInt(this.user_count);
    }
  }
  reasonId = "0";
  message = "";
  async validateSmsData(){
    if(this.reasonId == "0"){
      const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
      customToastr(pleaseSelectReasonTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.message)){
      const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
      customToastr(pleaseEnterMessageTranslation, 'error');
      return;
    }
  }


  allowToSendMessage = false;
  messageLength = 120;
  validateDataToSendSms(){
    if(this.reasonId == "0" || !this.formValidator.validateIsDataForNumber(this.message)){
      this.allowToSendMessage = false;
    }
    else {
      this.allowToSendMessage = true;
    }
    this.messageLength = 120;
    if(this.message.length == 0){
      this.messageLength = 120;
    }
    else {
      this.messageLength = this.messageLength - this.message.length;
    }
  }
  ngOnInit(){
    $(".after").append("<script>function momentJs(){return moment();}function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';toastr[type](message, title || '');return 0;}");
    this.fetchReason();
    this.fetchSubscriptionDetails();
    this.validateDataToSendSms();
  }

  // ===================================================================================================================
  //            SEND MESSAGE FUNCTION
  // ===================================================================================================================

  messageSending = false;
  async sendMessageOption(){
    if(this.reasonId == "0"){
      const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
      customToastr(pleaseSelectReasonTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.message)){
      const pleaseEnterMessageTranslation = await firstValueFrom(this.translate.get('pleaseEnterMessage')); 
      customToastr(pleaseEnterMessageTranslation, 'error');
      return;
    }
    if(this.sendTo == 'everyone'){
     this.sendMessageToEveryone();
    }
    else if(this.sendTo == 'staff'){
      this.sendMessageToAllStaff();
    }
    else if(this.sendTo == 'student') {
      if(this.studentType == 'ALL_STUDENT'){
        this.sendMessageToAllStudent();
      }
      else if(this.studentType == 'CLASS_WISE'){
        this.sendMessageClassWiseToAllStudent();
      }
    }
    else if(this.sendTo == 'SELECTIVE_STUDENT'){
      this.sendMessageToSelectiveStudent();
    }
  }
  sendMessageToEveryone(){
    this.messageSending = true;
    let data = {
      reasonId: this.reasonId,
      message: this.message,
      userType: this.userType
    };
    this.messageService.sendMessageToEveryoneService(data,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.messageSending = false;
          if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else if (data.data == true) {
            this.reasonId = '0';
            this.message = '';
            this.allowToSendMessage = false;
            const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
            customToastr(messageSentSuccessfullyTranslation, 'success');
            $("#cancelSendMessage").trigger('click');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.messageSending = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  sendMessageToAllStaff(){
    this.messageSending = true;
    let data = {
      reasonId: this.reasonId,
      message: this.message,
      userType: this.userType
    };
    this.messageService.sendMessageToAllStaffServices(data,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.messageSending = false;
          if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else if (data.data == true) {
            this.reasonId = '0';
            this.message = '';
            this.allowToSendMessage = false;
            const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
            customToastr(messageSentSuccessfullyTranslation, 'success');
            $("#cancelSendMessage").trigger('click');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.messageSending = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  sendMessageToAllStudent(){
    this.messageSending = true;
    let data = {
      reasonId: this.reasonId,
      message: this.message,
      userType: this.userType
    };
    this.messageService.sendMessageToAllStudentService(data,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.messageSending = false;
          if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else if (data.data == true) {
            this.reasonId = '0';
            this.message = '';
            this.allowToSendMessage = false;
            const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
            customToastr(messageSentSuccessfullyTranslation, 'success');
            $("#cancelSendMessage").trigger('click');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.messageSending = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async sendMessageClassWiseToAllStudent(){
    if(this.classList.length == 0){
      const pleaseSelectAtLeastOneClassTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneClass')); 
      customToastr(pleaseSelectAtLeastOneClassTranslation, 'error');
      return;
    }
    let class_list = [];
    for(let i=0; i<this.classList.length; i++){
      class_list.push(this.classList[i].classId);
    }
    this.messageSending = true;
    let data = {
      reasonId: this.reasonId,
      message: this.message,
      userType: this.userType,
      classList:class_list
    };
    this.messageService.sendClassWiseSmsToStudentService(data,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.messageSending = false;
          if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else if (data.data == true) {
            this.reasonId = '0';
            this.message = '';
            this.allowToSendMessage = false;
            const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
            customToastr(messageSentSuccessfullyTranslation, 'success');
            $("#cancelSendMessage").trigger('click');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.messageSending = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  sendMessageToSelectiveStudent(){
    this.messageSending = true;
    let data = {
      reasonId: this.reasonId,
      message: this.message,
      userType: this.userType,
      studentList:this.studentList,
      studentType:this.studentType
    };
    this.messageService.sendMessageToAllStudentService(data,this.getAuthToken)
      .subscribe(
        async (data: any) =>{
          this.messageSending = false;
          if (data.errorcode == "10038") {
            const noNumberFoundToSendSmsTranslation = await firstValueFrom(this.translate.get('noNumberFoundToSendSms')); 
            customToastr(noNumberFoundToSendSmsTranslation, 'error');
          }
          else if (data.data == true) {
            this.reasonId = '0';
            this.message = '';
            this.allowToSendMessage = false;
            const messageSentSuccessfullyTranslation = await firstValueFrom(this.translate.get('messageSentSuccessfully')); 
            customToastr(messageSentSuccessfullyTranslation, 'success');
            $("#cancelSendMessage").trigger('click');
          }
          else {
            const smsNotSentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('smsNotSentPleaseTryAgain')); 
            customToastr(smsNotSentPleaseTryAgainTranslation, 'error');
          }
        },
        async error =>{
          this.messageSending = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  // ===================================================================================================================
  //            SEND MESSAGE FUNCTION
  // ===================================================================================================================

}
